import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import GetHelpHeader from './GetHelpHeader';
import PopularArticles from './PopularArticles';
import OtherTopics from './OtherTopics';
import CurrentItemInfo from './CurrentItemInfo';

import { SelectedListing_viewer$key } from './__generated__/SelectedListing_viewer.graphql';

const SelectedListing: FC<{ viewer: SelectedListing_viewer$key }> = ({ viewer: viewerRef }) => {
    const viewer = useFragment(
        graphql`
            fragment SelectedListing_viewer on Viewer {
                ...CurrentItemInfo_viewer
                getHelpTopics(
                    orderId: $orderId
                    helpType: $helpType
                    isSeller: $isSeller
                    itemId: $itemId
                ) {
                    ...PopularArticles_getHelpTopics
                    ...OtherTopics_getHelpTopics
                }
            }
        `,
        viewerRef
    );

    const helpTopics = viewer.getHelpTopics;

    return (
        <div>
            <GetHelpHeader />
            <CurrentItemInfo viewer={viewer} />
            <PopularArticles getHelpTopics={helpTopics} />
            <OtherTopics getHelpTopics={helpTopics} />
        </div>
    );
};

export default SelectedListing;
